import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { key: String }

  connect() {
    this.element.addEventListener("click", this.toggle.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    document.querySelectorAll(`.data-${this.keyValue}`).forEach((el) => {
      el.classList.toggle("d-block")
    })

    document.querySelectorAll(`.form-${this.keyValue}`).forEach((el) => {
      el.value = el.value ? "" : "t"
    })

    this.element.querySelector(".toggle-icon")?.classList.toggle("text-white")
  }
}
